import React from 'react';
import { SuitableForVehicleChangeEventData } from '../../../types/commonTypes';
import TableNew from '../../../../core/components/table-components/table-new/TableNew';
import SuitableForVehiclesChangeColumns from './SuitableForVehiclesChangeColumns';
import SuitableForVehiclesChangeBody from './SuitableForVehiclesChangeRows';
import Pagination from '../../../../core/components/pagination/Pagination';
import { useSuitableForVehiclePagination } from './hooks/useSuitableForVehiclePagination';

type OldSuitableForVehiclesProps = {
  data: Omit<SuitableForVehicleChangeEventData, 'newSuitableForVehicles' | 'newSuitableForVehicleGroups'>;
}

const OldSuitableForVehicles: React.FC<OldSuitableForVehiclesProps> = ({
  data: { oldSuitableForVehicleGroups = [], oldSuitableForVehicles = [] },
}) => {
  const isGroup = !!oldSuitableForVehicleGroups.length && !oldSuitableForVehicles.length;
  const items = isGroup ? oldSuitableForVehicleGroups : oldSuitableForVehicles;

  const {
    PAGE_SIZE, page, setPage, totalItems, rows,
  } = useSuitableForVehiclePagination(items);

  return (
    <>
      <Pagination
        currentPage={page}
        pageSize={PAGE_SIZE}
        onChange={(page) => setPage(page)}
        totalItems={totalItems}
        showTotal={false}
        showSizeChanger={false}
        offsetBottom
      />
      <TableNew small>
        <SuitableForVehiclesChangeColumns isGroup={isGroup} />
        <SuitableForVehiclesChangeBody rows={rows} />
      </TableNew>
    </>
  );
};

export default OldSuitableForVehicles;
